import { useNotifyContext } from 'providers/NotifyProvider';
import { useEffect } from 'react';
import { useReportWorkplaceState } from './Reports';

const ReportUpdater = () => {
    const { fetchQuery } = useReportWorkplaceState();
    const { addSubscription, removeSubscription } = useNotifyContext();

    useEffect(() => {
        addSubscription({
            key: 'onReportStatusChange',
            type: 'ReportCreateFailed',
            callback: () => {
                fetchQuery.remove();
                fetchQuery.refetch();
            },
        });
        addSubscription({
            key: 'onReportStatusChange',
            type: 'ReportCreateComplete',
            callback: () => {
                fetchQuery.remove();
                fetchQuery.refetch();
            },
        });

        return () => {
            removeSubscription('onReportStatusChange');
        };
    }, []);

    return <></>;
};

export default ReportUpdater;
